import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import MultiRadio from "../../../../../components/FormComponents/MultiRadio";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditIdGen = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  const handleChangeIdGenConfigInput = (name, value) => {
    setEditFieldData({ ...editFieldData, id_gen_config: { ...editFieldData.id_gen_config, [name]: value } });
  };

  const options = [
    { id: "na", name: "Never" },
    { id: "daily", name: "Daily" },
    { id: "monthly", name: "Monthly" },
    { id: "yearly", name: "Yearly" }
  ];
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      {/* Id gen config */}
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("sequence")}
          checked={editFieldData.id_gen_config.sequence}
          name="sequence"
          onChange={({ target }) => handleChangeIdGenConfigInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("prefix")}
          value={editFieldData.id_gen_config.prefix}
          name="prefix"
          onChange={({ target }) => handleChangeIdGenConfigInput(target.name, target.value)}
          containerClassName="w_50"
        />
        <Input
          label={getLabelForKey("date_format")}
          value={editFieldData.id_gen_config.date_format}
          name="date_format"
          onChange={({ target }) => handleChangeIdGenConfigInput(target.name, target.value)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <MultiRadio
          keyName="mode"
          selectedValue={editFieldData.id_gen_config.reset_type}
          options={options}
          onChange={({ target }) => handleChangeIdGenConfigInput("reset_type", target.value)}
          label="Request frequency"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditIdGen;
